import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  WmsInvoiceCheckbox: {
    SalesOrder: false,
    UnitRateLC: false,
    LDisc: false,
    TDisc: false,
    Foc: false,
    Excise: false,
    TaxAmt: true,
    TaxDept1: true,
    TaxDept2: false,
    AddCess: false,
    Narration: true,
    Incentive: true,
  },
};
// TypeReduce CostDis%cDiscAmt
const sliceWmsInvoiceTag = createSlice({
  name: "sliceWmsInvoiceTag",
  initialState: { value: initialState },

  reducers: {
    SetWmsInnModelCheckbox: (state, action) => {
      state.value.WmsInvoiceCheckbox = action.payload;
    },

    ClearWmsInvoiceTag: (state) => {
      state.value = initialState;
    },
  },
});

export const { SetWmsInnModelCheckbox, ClearWmsInvoiceTag } =
  sliceWmsInvoiceTag.actions;
export default sliceWmsInvoiceTag.reducer;
